import React, { useState, useEffect } from 'react';
import deThiTracNghiem from '../../api/de';
import { FaArrowLeft, FaArrowRight, FaCheckCircle } from 'react-icons/fa';
import './style.scss';

const Quiz = ({ quizId, onSubmit, onBack }) => {
  const quiz = deThiTracNghiem.find((d) => d.id === quizId);
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState(Array(quiz.cauHoi.length).fill(null));

  useEffect(() => {
    setCurrent(0);
    setAnswers(Array(quiz.cauHoi.length).fill(null));
  }, [quizId]);

  const handleSelect = (idx, ans) => {
    const newAns = [...answers];
    newAns[idx] = ans;
    setAnswers(newAns);
  };

  const handleNext = () => setCurrent((c) => Math.min(c + 1, quiz.cauHoi.length - 1));
  const handlePrev = () => setCurrent((c) => Math.max(c - 1, 0));

  const handleSubmit = () => {
    let score = 0;
    quiz.cauHoi.forEach((q, idx) => {
      if (answers[idx] === q.cauTraLoiDung) score++;
    });
    // Lưu điểm vào localStorage
    localStorage.setItem(`quiz_score_${quizId}`, score);
    onSubmit(
      quiz.cauHoi.map((q, idx) => ({ cauHoiId: q.id, answer: answers[idx] })),
      score
    );
  };

  const q = quiz.cauHoi[current];
  const isAnswered = answers[current] !== null;

  return (
    <div className="quiz-bg">
      <div className="quiz-header">
        <button className="quiz-back-btn" onClick={onBack}>
          <FaArrowLeft /> Quay lại
        </button>
        <div className="quiz-progress">Câu {current + 1}/{quiz.cauHoi.length}</div>
      </div>
      <div className="quiz-question rainbow-text">{q.noiDung}</div>
      <div className="quiz-answers">
        {Object.entries(q.dapAn).map(([k, v]) => (
          <div
            key={k}
            className={`quiz-answer-card ${answers[current] === k ? 'selected' : ''}`}
            onClick={() => handleSelect(current, k)}
          >
            <span className="quiz-answer-label">{k}</span>
            <span className="quiz-answer-text">{v}</span>
          </div>
        ))}
      </div>
      <div className="quiz-footer">
        <button className="quiz-nav-btn" onClick={handlePrev} disabled={current === 0}>
          <FaArrowLeft />
        </button>
        {current < quiz.cauHoi.length - 1 ? (
          <button className="quiz-nav-btn" onClick={handleNext} disabled={!isAnswered}>
            <FaArrowRight />
          </button>
        ) : (
          <button className="quiz-submit-btn" onClick={handleSubmit} disabled={answers.includes(null)}>
            <FaCheckCircle /> Nộp bài
          </button>
        )}
      </div>
    </div>
  );
};

export default Quiz; 